const links = {
  rxsto: 'https://rxs.to',
  pikisuperstar:
    'https://www.freepik.com/free-vector/hand-painted-watercolor-pastel-sky-background_13451525.htm',
};

export default links;
